<template>
  <div class="myOrder">
    <h3>我的订单</h3>
    <!--导航-->
    <nav class="nav">
      <ul>
        <li :class="status === index ? 'on' : '' " v-for="(item, index) in nav" :key="index" @click="handleClick(index)">{{item}}</li>
      </ul>
    </nav>
    <!--订单列表-->
    <div class="list">
      <ul>
          <!--快递-->
        <li class="searchItem" v-for="(item, index) in orderList" :key="item.id" v-if="status === item.orderStatus ? (status === item.orderStatus) : true" @click="toDetail(item.id, item.orderType)">
          <div class="itemTop">
            <div>
              <p class="type" :class="orderType(item.orderType)">{{orderItem(item.orderType)}}</p>
              <p class="code">订单编码：<span>{{item.orderSn}}</span></p>
            </div>
            <p class="time">{{item.createDate}}</p>
          </div>
          <div class="itemMiddle">
            <div>
              <p class="price">￥{{item.totalAmount}}</p>
              <p class="server_fee">服务费 <span>￥{{item.serviceFee}}</span></p>
              <p class="server_fee">加价 <span>￥{{item.addFee}}</span></p>
            </div>
            <p class="pay">{{orderStatus(item.orderStatus,item)}}</p>
          </div>
          <div class="itemBottom">
            <div>
              <p class="send ellipsis"><span class="check">{{orderAddress1(item.orderType)}}</span>{{check(item.desc)}}</p>
              <p class="collect ellipsis"><span class="collect">{{orderAddress2(item.orderType)}}</span>{{put(item.desc)}}</p>

            </div>
            <div class="payBtn">
              <button class="btn1" @click.stop="pay(item.orderType, item.orderStatus, item.paymentSn, item.totalAmount, item.id,item)" v-if="orderStatusBtn(item.orderStatus).length && item.totalAmount > 0">{{orderStatusBtn(item.orderStatus)}}</button>
              <button class="btn2" @click.stop="cancleOrder(item.orderStatus, item.id)" v-if="orderStatusBtn2(item.orderStatus,item).length">{{orderStatusBtn2(item.orderStatus,item)}}</button>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <!--分页-->
    <div class="pagin">
      <pagination :pageCount="pageCount" @pageSize="pageSize"/>
    </div>
    <pay-way v-if="isShow" @close="close" />
    <rate v-if="isShowRate" :orderNum="orderNum" @closeRate="closeRate" />
  </div>
</template>

<script>
import Pagination from '../../../components/Pagination'
import PayWay from '../../../components/Pay/PayWay'
import Rate from '../../../components/Person/Rate'
import {reqAllOrder, reqCancelOrder,getAdditionalOrder } from '../../../api'
export default {
  data () {
    return {
      nav: ['全部', '待支付', '待接单', '进行中', '待评价', '已完成','已取消'],
      orderList: [], // 订单列表
      status: 0, // 支付导航状态
      pageCount: 0, // 总页数
      isShow: false, // 是否显示支付方式
      isShowRate: false, // 是否显示评论
      orderNum: '' // 订单号
    }
  },
  created() {
    this.getOrderType()
  },
  methods: {
    // 获取订单类型
    getOrderType() {
      let {status} = this.$route.query
      console.log(status)
      switch (Number(status)) {
        case 1:     // 1待支付2待抢单3取件中4派送中5受理中6追加费用7待评价8已完成9已取消
          this.status = 1
          break
        case 2:
          this.status = 2
          break
        case 4:
          this.status = 3
          break
        case 7:
          this.status = 4
          break
        case 8:
          this.status = 5
          break
      }
      this._reqAllOrder(1, 10, status)
    },
    // 寄地址
    check(address) {
      if(address) {
        return (address.split('/n'))[0]
      }
    },
    // 收地址
    put(address) {
      if(address) {
        return (address.split('/n'))[1]
      }
    },
    // 关闭支付方式
    close() {
      this.isShow = !this.isShow
    },
    // 关闭评论
    closeRate() {
      this.isShowRate = !this.isShowRate
    },
    // 获取总订单列表
    _reqAllOrder(pageIndex, pageSize=10, orderStatusIn) {
      let body = {}
      if(orderStatusIn) {
        body = {pageIndex, pageSize, orderStatusIn}
      }else {
        body = {pageIndex, pageSize}
      }
      reqAllOrder(body).then(res => {
        console.log(res)
        if (res.code === 200) {
          this.pageCount = res.data.pageCount
          this.orderList = res.data.bussData
        }
      })
    },
    // 获取当前第几页
    pageSize(num) {
      let {status} = this.$route.query
      console.log(status,this.num)
      if(status == 4) {
        this._reqAllOrder(num, 10, [3,4,5,6])
      } else if(status == 8){
        this._reqAllOrder(num, 10, [8,9])

      }else{
        this._reqAllOrder(num, 10, status)

      }

    },
    // 类型颜色
    orderType (type) {
      switch (type) {
        case 1 :
          return 'express'
        case 2 :
          return 'express'
        case 3 :
          return 'medical'
        case 4 :
          return 'ticket'
        case 5 :
          return 'other'
        case 10 :
          return 'other'
        case 20:
          return 'other'
      }
    },
    // 类型
    orderItem (type) {
      switch (type) {
        case 1 :
          // 同城快递
          return '快递'
        case 2 :
          // 国内快递
          return '快递'
        case 3 :
          return '医疗'
        case 4 :
          return '票务'
        case 5 :
          return '其他'
        case 10 :
          return '其他'
        case 20:
          return '其他'
      }
    },
    // 支付状态
    orderStatus (status,item) {
      switch (status) {
        case 1 :
          return '待支付'
        case 2 :
          return '待抢单'
        case 3 :

          return '进行中'
        case 4 :
           if(item.orderType == 1){
            return '派送中'
          }
          return '进行中'
        case 5 :
          return '进行中'
        case 6 :
          return '追加费用待支付'
        case 7:
          return '待评价'
        case 8:
          return '已完成'
        case 9:
          return '已取消'
      }
    },
    // 地址状态
    orderAddress1(type) {
      switch (type) {
        case 1 :
          return '寄'
        case 2 :
          return '寄'
        case 3 :
          return '医院'
        case 4 :
          return '票'
        case 5 :
          return '事'
        case 10 :
          return '事'
        case 20:
          return '事'
      }
    },
    orderAddress2(type) {
      switch (type) {
        case 1 :
          return '收'
        case 2 :
          return '收'
        case 3 :
          return '科'
        case 4 :
          return '时'
        case 5 :
          return '址'
        case 10 :
          return '址'
        case 20:
          return '址'
      }
    },
    // 支付状态按钮
    orderStatusBtn (status) {
      switch (status) {
        case 1 :
          return '支付'
        case 2 :
          return ''
        case 3 :
          return ''
        case 4 :
          return ''
        case 5 :
          return ''
        case 6 :
          return '支付'
        case 7:
          return ''
        case 8:
          return ''
        case 9:
          return ''
      }
    },
    // 支付状态按钮
    orderStatusBtn2 (status,item) {

      //  当是同城快递 且已经取件之后  不允许取消接单
      // TODO

      switch (status) {
        case 1 :
          return '取消订单'
        case 2 :
          return '取消接单'
        case 3 :
          return '取消接单'
        case 4 :

          if(item.orderType==1){

            return ''
          }
          return '取消接单'
        case 5 :
          return '取消接单'
        case 6 :
          return '取消接单'
        case 7:
          return '评价'
        case 8:
          return ''
        case 9:
          return ''
      }
    },
    handleClick (i) {
      switch (i) {
        case 0:     // 1待支付2待抢单3取件中4派送中5受理中6追加费用7待评价8已完成9已取消
          this.status = 0
          this.$router.push({name: 'Order'})
          this._reqAllOrder(1, 10)
          break
        case 1:
          this.status = 1
          this.$router.push({name: 'Order', query: {status: 1}})
          this._reqAllOrder(1, 10, [1])
          break
        case 2:
          this.status = 2
          this.$router.push({name: 'Order', query: {status: 2}})
          this._reqAllOrder(1, 10, [2])
          break
        case 3:
          this.status = 3
          this.$router.push({name: 'Order', query: {status: 4}})
          this._reqAllOrder(1, 10, [3,4,5,6])
          break
        case 4:
          this.status = 4
          this.$router.push({name: 'Order', query: {status: 7}})
          this._reqAllOrder(1, 10, [7])
          break
        case 5:
          this.status = 5
          this.$router.push({name: 'Order', query: {status: 8}})
          this._reqAllOrder(1, 10, [8, 9])
          break
	    case 6:
		  this.status = 6
		  this.$router.push({name: 'Order', query: {status: 9}})
		  this._reqAllOrder(1, 10, [9])
		  break
      }
    },
    // 第一个按钮
    pay (type, status, paymentSn, payFee, id,item) {
       if(status == 6){
        // 追加支付
        getAdditionalOrder(item.id).then(res=>{
          if(res.data.resultCode==200){
               this.$store.dispatch('getOrderInfo', res.data.bussData).then(() => {
                   this.close()
              })
          }
        })
        return
      }
      if(status === 1 ) {
        this.$store.dispatch('getOrderInfo', {paymentSn, payFee}).then(() => {
          this.close()
        })
      } else if(type == 1 || type == 2) {
        this.$router.push({name: 'ExpressAgain', query:{id, type}})
      } else if(type == 3) {
        this.$router.push({name: 'HospitalAgain', query:{id}})
      } else if(type == 4) {
        this.$router.push({name: 'TicketAgain', query:{id}})
      } else{
         this.$router.push({name: 'OtherAgain', query:{id}})
      }
    },
    // 第二个按钮
    cancleOrder (status, id) {
      if(status === 7) {
        this.orderNum = id
        this.closeRate()
      } else {
        reqCancelOrder(id).then(res => {
          if(res.code === 200) {
            this.$message({
              message: '取消订单成功',
              type: 'success'
            })
            this.$store.dispatch('recordUserBaseInfo')
            this.getOrderType()
          }
        })
      }
    },
    // 查看详情
    toDetail(id, type, orderSn) {
      switch (type) {
        case 1 :
          this.$router.push({name: 'ExpressOrderDetail', query:{id, type}})
          break
        case 2 :
          this.$router.push({name: 'ExpressOrderDetail', query:{id, type}})
          break
        case 3 :
          this.$router.push({name: 'HosOrder', query:{id}})
          break
        case 4 :
          this.$router.push({name: 'TicketOrderDetail', query:{id}})
          break
        case 5 :
          this.$router.push({name: 'OtherOrderDetail', query:{id}})
          break
        case 10 :
          this.$router.push({name: 'OtherOrderDetail', query:{id}})
          break
        case 20:
          this.$router.push({name: 'OtherOrderDetail', query:{id}})
          break
      }
    },

  },
  computed: {

  },
  components: {
    Pagination,
    Rate,
    PayWay
  }
}
</script>

<style scoped lang="less" type="text/less">
.myOrder{
  h3{
    font-size: 24px;
    margin-top:60px;
  }
  .nav{
    margin-top:30px;
    padding-bottom: 40px;
    border-bottom:1px solid #e1e1e1;
    ul{
      display: flex;
      li{
        padding:10px 26px;
        border-radius: 18px;
        font-weight: bold;
        cursor: pointer;
        &.on{
          background: #2FA1DE;
          color:#fff;
        }
      }
    }
  }
  .list{
    margin-top:30px;
    .searchItem{
      margin-bottom: 20px;
      padding:16px 20px;
      box-sizing: border-box;
      border:1px solid #f4f4f4;
      box-shadow: 0 8px 10px 0 rgba(0,5,28,0.1);
      .itemTop{
        display: flex;
        justify-content: space-between;
        line-height: 30px;
        div:first-of-type{
          display: flex;
          .type{
            width: 68px;
            height: 30px;
            margin-right: 25px;
            border-radius: 15px;
            color:#fff;
            text-align: center;
            &.express{
              background: #61aee6;
            }
            &.medical{
              background: #FFBFBF;
            }
            &.ticket{
              background: #26D3B0;
            }
            &.other{
              background: #FFC168;
            }
          }
          .code{
            font-size: 16px;
            color:#333;
            span{
              color: #999;
            }
          }
        }
        .time{
          font-size: 14px;
          color:#999;
        }

      }
      .itemMiddle{
        display: flex;
        justify-content: space-between;
        margin-top:16px;
        div:first-of-type{
          display: flex;
          .price{
            color:#F70101;
            font-weight: 500;
            margin-right:40px;
          }
          .weight{
            color: #333;
            font-size: 14px;
          }
          .server_fee{
            margin-right: 26px;
            font-size: 14px;
            color: #333;
            span{
              color: #F70101;
            }
          }
        }
        .pay{
          font-size: 14px;
          font-weight: 500;
          color: #61aee6;
          cursor: pointer;
        }
      }
      .itemBottom{
        position: relative;
        display: flex;
        justify-content: space-between;
        margin-top:20px;
        div:first-of-type{
          p{
            width: 323px;
            color:#333;
            font-size: 14px;
            margin-bottom: 20px;
            font-weight: 500;
            span{
              display: inline-block;
              width: 35px;
              height: 20px;
              margin-right: 9px;
              border-radius: 4px;
              text-align: center;
              line-height: 20px;
              color:#fff;
              &.check{
                background: #2FA1DE;
              }
              &.collect{
                background: #FFC168;
              }
            }
          }
        }
        .payBtn{
          position: absolute;
          right: 0;
          bottom: 28px;
          height: 14px;
          font-size: 14px;
          button{
            width: 84px;
            height: 36px;
            margin-left: 20px;
            border:none;
            box-sizing: border-box;
            border-radius: 18px;
            cursor: pointer;
            &.btn1{
              background: #2FA1DE;
              color:#fff;
            }
            &.btn2{
              background: #fff;
              border:1px solid #e1e1e1;
            }
          }
        }
      }
    }
  }
  .pagin{
    margin: 40px 0 60px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Person/Children/MyOrder.vue